import React, { useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../Navigation/Navbar';
import { LayoutContext } from '../../utils/contexts/LayoutContext';

export default function BaseLayout() {
  const { padding } = useContext(LayoutContext);

  const [menuHidden, setMenuHidden] = useState(false);

  return (
    <div className="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900 dark:text-white">
      <Navbar menuHidden={menuHidden} />
      <div className="flex flex-1">
        <main className={`flex-1 ${padding ?? 'p-4'} `}>
          <Outlet context={{ setMenuHidden }} />
        </main>
      </div>
      <footer
        className="py-6 px-4 md:px-8 text-center text-sm
      bg-gray-900 text-white border-t border-gray-700"
      >
        <p>
          &copy; {new Date().getFullYear()} Smash Index. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
